import { Icons } from '@/assets';

export const AuthLogo = () => {
  return (
    <div className="flex justify-center mb-5">
      <Icons.LogoText className="h-5 text-black" />
    </div>
  );
};
